import { useEffect } from 'react'

const INITIAL_MOUNT_Y_OFFSET = 25
const CARD_WIDTH = 300
const CARD_GAP = 30
const CARD_HEADER_HEIGHT = 57
const CARD_BODY_PADDING = 32
const PHASE_GAP = 16
const PHASE_TITLE_HEIGHT = 20
const PHASE_TITLE_GAP = 8
const SLOT_HEIGHT = 36
const SLOT_GAP = 8

export default function WorkoutCanvasTab({
    viewportRef,
    setTransform = () => {},
    workoutConfigs = []
}) {

    const BuildWorkoutConfigLayouts = (workoutConfigs) => {
        let offsetX = 0

        return workoutConfigs.map((workoutConfig) => {
            const layout = {
                workoutConfig,
                x: offsetX,
                y: 0,
                width: CARD_WIDTH,
                height: __EstimateWorkoutConfigHeight(workoutConfig),
            }

            offsetX += layout.width + CARD_GAP
            return layout
        })
    }
    
    const __EstimateWorkoutConfigHeight = (workoutConfig) => {
        const phases = workoutConfig.workoutPhaseConfigs ?? []
    
        const bodyHeight = phases.reduce((total, phase, phaseIndex) => {
            const slotCount = phase.workoutSlotConfigs?.length ?? 0
            const slotsHeight = slotCount === 0
                ? 0
                : slotCount * SLOT_HEIGHT + (slotCount - 1) * SLOT_GAP
    
            return total
                + (phaseIndex > 0 ? PHASE_GAP : 0)
                + PHASE_TITLE_HEIGHT
                + (slotCount > 0 ? PHASE_TITLE_GAP : 0)
                + slotsHeight
        }, 0)
    
        return CARD_HEADER_HEIGHT + CARD_BODY_PADDING + bodyHeight
    }

    useEffect(() => {
        if (workoutConfigs === null) return

        const viewport = viewportRef?.current
        if (!viewport) return

        const layouts = BuildWorkoutConfigLayouts(workoutConfigs)
        const lastLayout = layouts[layouts.length - 1]
        const boardWidth = lastLayout ? lastLayout.x + lastLayout.width : 0
        const boardHeight = layouts.reduce((maxHeight, layout) => Math.max(maxHeight, layout.height), 0)

        const { width, height } = viewport.getBoundingClientRect()

        setTransform({
            x: Math.max(0, width / 2 - boardWidth / 2),
            y: Math.max(0, height / 2 - boardHeight / 2 + INITIAL_MOUNT_Y_OFFSET),
            zoom: 1,
        })
    }, [workoutConfigs, viewportRef, setTransform])

    const workoutConfigLayouts = BuildWorkoutConfigLayouts(workoutConfigs)

    return (
        <div>
            {workoutConfigLayouts.map(({ workoutConfig, x, y, width }) => (
                <div
                    key={workoutConfig.workoutConfigId}
                    className="absolute overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-md"
                    style={{
                        left: x,
                        top: y,
                        width,
                    }}
                    onPointerDown={(event) => event.stopPropagation()}
                >
                    <div className="border-b border-gray-200 p-4">
                        <p className="text-left text-base font-medium text-gray-900">
                            {workoutConfig.name}
                        </p>
                    </div>

                    <div className="space-y-4 p-4">
                        {workoutConfig.workoutPhaseConfigs.map((workoutPhaseConfig, workoutPhaseConfigIndex) => (
                            <div
                                key={workoutPhaseConfigIndex}
                                className="space-y-2"
                            >
                                <p className="text-left text-sm font-medium text-gray-700">
                                    {workoutPhaseConfig.name}
                                </p>

                                {workoutPhaseConfig.workoutSlotConfigs.map((workoutSlotConfig, workoutSlotIndex) => (
                                    <div
                                        key={workoutSlotIndex}
                                        className="rounded-xl bg-gray-100 px-4 py-2 relative"
                                    >
                                        <p className="text-center text-sm text-gray-600">
                                            Slot {workoutSlotIndex + 1}
                                        </p>

                                        {workoutSlotConfig?.supportedWorkoutLengthsJSON?.length > 0 && (
                                            <div className="absolute top-2.5 left-2.5">
                                                <p className='text-xs text-gray-500'>[{workoutSlotConfig.supportedWorkoutLengthsJSON.join(', ')}]</p>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}
